import React, { useMemo, useState } from 'react'

import urlJoin from 'url-join'

import { t } from 'src/translations'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import useWindowMessage from 'shared/js/hooks/useWindowMessage'

import { AdyenMessage } from 'public/components/default_template/online_ordering/checkout/international/types'

import { resources } from 'config'

type Props = {
  checkAmount: number
  email: string
  onPaymentCompleted: (paymentIntentID: string) => void
  onPaymentSubmitted?: () => void
  onPaymentFailed?: () => void
}

const AdyenGiftCardPaymentIFrame = ({
  checkAmount,
  email,
  onPaymentCompleted,
  onPaymentSubmitted,
  onPaymentFailed
}: Props) => {
  const [height, setHeight] = useState('100%')
  const { ooRestaurant } = useRestaurant()

  useWindowMessage({
    origin: resources.sitesHost,
    sourceId: 'ADYEN_PAYMENT',
    messageHandlers: {
      [AdyenMessage.HEIGHT]: (data: { height: string }) =>
        setHeight(data.height),
      [AdyenMessage.SHOW_OVERLAY]: () => onPaymentSubmitted?.(),
      [AdyenMessage.HIDE_OVERLAY]: () => onPaymentFailed?.(),
      [AdyenMessage.PLACE_ORDER]: (data: { paymentIntentID: string }) =>
        onPaymentCompleted(data.paymentIntentID)
    }
  })

  const src = useMemo(() => {
    const params = new URLSearchParams({
      shortUrl: ooRestaurant?.shortUrl ?? '',
      flow: 'giftcard',
      channel: 'EGIFTCARD',
      checkAmount: checkAmount.toString(),
      tipAmount: '0',
      email,
      origin: typeof window !== 'undefined' ? window.location.origin : ''
    })

    return urlJoin(
      resources.sitesHost,
      'sites-web/v1/adyen',
      '?' + params.toString()
    )
  }, [ooRestaurant, checkAmount, email])

  return (
    <iframe
      key={`giftcard-${checkAmount}`}
      title={t('adyen-payment-iframe.adyen-payment')}
      allow='payment; camera; microphone'
      width='100%'
      height={height}
      style={{ border: 0 }}
      src={src}
    />
  )
}

export default AdyenGiftCardPaymentIFrame
